import Image from '@/components/Image';
import Link from '@/components/Link';
import MarketingSection from './MarketingSection';

function TrainerPicture({
  title,
  sizes,
  srcSet,
  sourceUrl,
}) {
  return (
    <div className="flex w-full h-60 bg-white shadow-lg rounded-xl bg-center bg-cover bg-no-repeat" style={{ backgroundImage: `url(${sourceUrl})` }}>
      <Image alt={`Imagen de ${title}`} srcSet={srcSet} sizes={sizes} src={sourceUrl} className="hidden" />
    </div>
  );
}

export default function MarketingTrainers({
  trainers,
}) {
  return (
    <MarketingSection sectionTitle="¡Conoce nuestros entrenadores!" className="bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mx-auto max-w-screen-md">
        {trainers.map(({ id, title, excerpt, uri, featuredImage }) => (
          <div key={id} className="lg:col-span-12">
            <div className="flex flex-col md:flex-row lg:items-stretch">
              <div className="flex mb-6 md:mb-0 md:w-1/4">
                <TrainerPicture title={title} {...featuredImage.node} />
              </div>
              <div className="leading-relaxed md:w-2/3 md:pl-10 lg:flex lg:flex-col lg:justify-center">
                <h4 className="text-lg lg:text-xl font-medium">
                  {title}
                </h4>
                <div className="prose font-normal" dangerouslySetInnerHTML={{ __html: excerpt }} />
                <Link className="font-medium text-gray-900 hover:text-gray-700 transition ease-in-out duration-300 inline-flex items-center space-x-1" href={uri} target="_blank" rel="noopener noreferrer">
                  <div>
                    Ir al perfil de entrenador
                  </div>
                  <svg className="w-4 h-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </MarketingSection>
  );
}
